import { Image, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { shareLinks } from '@hero/data';

import * as S from './style';

export function ShareAnywhere() {
  const { t } = useTranslation();

  return (
    <S.ShareAnywhere>
      <Typography variant="body1Bold">{t('shareAnywhere')}</Typography>
      <Typography variant="body1">{t('individualUploadImageContainerSubTitle')}</Typography>
      <S.ShareLinks>
        {shareLinks.map(({ name, label, logo }) => (
          <S.ShareLink key={name}>
            <Image src={logo} alt={name} width={24} height={24} />
            <Typography variant="body2" color="fg" emphasis="weaker">
              {label}
            </Typography>
          </S.ShareLink>
        ))}
      </S.ShareLinks>
    </S.ShareAnywhere>
  );
}
